var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "align-stretch justify-start" },
        [
          _c(
            "v-col",
            { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
            [
              _c("LastPlayersSearch", {
                staticClass: "mr-3 flex-grow-1",
                staticStyle: { "min-height": "260px" },
                on: {
                  heightChange: function ($event) {
                    _vm.lastPlayersSearchHeight = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
            [
              _c("FavoritesWidget", {
                staticClass: "mr-3 flex-grow-1",
                style: { height: _vm.lastPlayersSearchHeight + "px" },
                attrs: { userId: _vm.currentUser.id },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("CollectionsWidget", {
                staticClass: "flex-grow-1",
                style: { height: _vm.lastPlayersSearchHeight + "px" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("LastScoutingAnalysesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("ScoutingTasksWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("UploadedGamesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("CapturePlaylistsWidget")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }